/* global jQuery */
import React from 'react'

const initOutbrain = function () {
  try {
    if(jQuery('.sponsored-headlines').length > 0) {
      var cb = () => {
        jQuery('.OUTBRAIN').attr('data-ob-mark', '')
        window.OBR.extern.researchWidget()
      }
      window.OBR ? cb() : jQuery.getScriptCache('http://widgets.outbrain.com/outbrain.js')
    }
  } catch(err) {
    console.error(err)
  }
}

export function renderOutbrain(props) {
  const { id = 'AR_49' } = props
  try {
    jQuery('[data-ob-template]').attr('class', 'OUTBRAIN').attr('data-widget-id', id)
    window.OBR ? window.OBR.extern.researchWidget() : jQuery.getScriptCache('http://widgets.outbrain.com/outbrain.js')    
  } catch(err) {
    console.error(err)
  }
}

export default class Outbrain extends React.Component {
  componentDidMount() {
    initOutbrain()
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.url !== this.props.url || nextProps.id !== this.props.id) {
      return true
    }
    return false
  }

  componentDidUpdate() {
    initOutbrain()
  }

  render() {
    const {
      className = 'OUTBRAIN',
      headline = 'Sponsored Headlines',
      template = 'ESPNCricinfo',
      id = '',
      showHeadline = true,
      url
    } = this.props

    if(id === '') {
      return <span/>
    }

    let obProps = {
      className: className,
      'data-widget-id': id,
      'data-src': url,
      'data-ob-template': template
    }
    
    let headerStyle = {
      'color': '#6c6d6f',
      'fontSize': '14px',
      'fontWeight': '600',
      'margin': '0 0 10px',
      'textTransform': 'uppercase'
    }

    let obHeadline = showHeadline === true ? <h2 style={ headerStyle }>{ headline }</h2> : ''

    return (
      <div className="sponsored-headlines">
      {obHeadline}
      <div {...obProps}/>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/components/common/Outbrain.jsx
 **/